import {
   Component,
   ComponentFactoryResolver,
   ComponentRef,
   EventEmitter,
   Input,
   Output,
   ViewChild,
   ViewContainerRef,
} from "@angular/core";
import { MatLegacyButton as MatButton } from "@angular/material/legacy-button";
import { MatLegacyOption as MatOption } from "@angular/material/legacy-core";
import { MatLegacySelect as MatSelect } from "@angular/material/legacy-select";
import { TranslateService } from "@ngx-translate/core";
import * as $ from "jquery";

import { IdexService } from "../../../idex.service";
import { DefaultTo } from "../../../shared/defaultTo.decorator";
import { DocTypeComponent } from "../../../shared/doctype.component";
import { zDoxItem } from "../../../shared/types";
import { MetadataService } from "./services/metadata.service";
import {
   InfoPanelConfig,
   MetadataFormProperty,
   MetadataFormType,
   defaultConfig,
} from "./viewer-info-panel.types";

@Component({
   selector: "app-viewer-info-panel",
   templateUrl: "./viewer-info-panel.component.html",
   styleUrls: ["./viewer-info-panel.component.css"],
})
export class ViewerInfoPanelComponent {
   @Input() @DefaultTo(defaultConfig) config: InfoPanelConfig;
   @Input() doc: zDoxItem;
   @Input() certData: any;
   // DETAILS EVENT OUTPUTS
   @Output() saveEdittedDescription = new EventEmitter<string>();

   // COMMENT EVENT OUTPUTS
   @Output() saveEdittedComment = new EventEmitter<{
      originalItem: ViewerInfoPanelComponent["comment"];
      edittedContent: string;
   }>();
   @Output() postNewComment = new EventEmitter<{
      content: string;
      isPostSuccess: (isSuccess: boolean) => void;
   }>();
   @Output() deleteComment = new EventEmitter<
      ViewerInfoPanelComponent["comment"]
   >();

   // METADATA EVENT OUTPUTS
   @Output() saveMetadataType = new EventEmitter<{
      formType: MetadataFormType;
      properties: MetadataFormProperty[];
      isSaveTypeSuccess: (isSuccess: boolean) => void;
   }>();

   constructor(
      protected service: IdexService,
      private translate: TranslateService,
      public metadataService: MetadataService,
      private resolver: ComponentFactoryResolver
   ) {
      this.translate.get("send").subscribe((s) => {
         this.postCommentButtonText = s;
      });
      this.translate.get("save").subscribe((s) => {
         this.saveText = s;
      });
      metadataService.properties$.subscribe((properties) => {
         if (properties) this.loadForm1(properties);
      });
   }

   //====================================================================================================
   // MAT-TAB: DETAILS
   //====================================================================================================

   saveDescription(e: FocusEvent): void {
      this.saveEdittedDescription.emit((<HTMLTextAreaElement>e.target).value);
   }

   //====================================================================================================
   // MAT-TAB: COMMENTS
   //====================================================================================================

   // TODO: Refactor comment editing to be like file renaming in onedrive-list (type-safe, no setTimeout).
   comment: zDoxItem["comments"] | any;
   postCommentButtonText: string;

   private getComment(): void {
      this.service.getComment(this.doc.id).subscribe((data) => {
         this.comment = data.items;
      });
   }

   saveComment(
      item: ViewerInfoPanelComponent["comment"],
      input: HTMLTextAreaElement
   ): void {
      if (input.value.trim().length === 0) {
         return;
      }
      this.saveEdittedComment.emit({
         originalItem: item,
         edittedContent: input.value,
      });
   }

   editComment(item: ViewerInfoPanelComponent["comment"]): void {
      item.editing = true;
      setTimeout(() => {
         $("#edit-" + item.id).focus();
      }, 200);
   }

   delComment(item: ViewerInfoPanelComponent["comment"]): void {
      this.deleteComment.emit(item);
   }

   postComment(button: MatButton, input: HTMLTextAreaElement): void {
      const text = input.value.trim();
      if (text.length === 0) {
         input.focus();
         return;
      }
      button.disabled = true;
      this.translate.get("sending").subscribe((s) => {
         this.postCommentButtonText = s;
      });

      const isCommentPostSuccess = (isSuccess: boolean) => {
         if (isSuccess) {
            input.value = "";
            this.translate.get("sended").subscribe((s) => {
               this.postCommentButtonText = s;
            });
            setTimeout(() => {
               this.resetSendCommentButton(button);
            }, 3000);
         } else {
            this.resetSendCommentButton(button);
         }
      };

      this.postNewComment.emit({
         content: text,
         isPostSuccess: isCommentPostSuccess,
      });
   }

   private resetSendCommentButton(button: MatButton) {
      button.disabled = false;
      this.translate.get("send").subscribe((s) => {
         this.postCommentButtonText = s;
      });
   }

   //====================================================================================================
   // MAT-TAB: METADATA
   //====================================================================================================

   @ViewChild("selectType") selectType: MatSelect;
   @ViewChild("form1", { read: ViewContainerRef }) form1: ViewContainerRef;
   @ViewChild("form2", { read: ViewContainerRef }) form2: ViewContainerRef;
   private form: MetadataFormProperty[];
   private componentRef1: ComponentRef<{}>;
   private componentRef2: ComponentRef<{}>;

   types: any;
   settype: any;
   saveText: any;
   selectedValue: string;

   private getProperties(formProperties: MetadataFormProperty[]) {
      const error = function (e, msg) {
         e.focus();
         return null;
      };
      const properties = {};
      for (const property of formProperties) {
         const f = property;
         const e = $("#" + f.name.replace(":", "_"));
         const value = e.val();
         if (f.mandatory && !value) {
            return error(e, f.label + " is required");
         }
         if (f.constraints && value) {
            // Handling string type
            if (typeof value === "string") {
               if (
                  f.constraints.minLength &&
                  value.length < f.constraints.minLength
               ) {
                  return error(
                     e,
                     "Minimum length of " +
                        f.label +
                        " is " +
                        f.constraints.minLength +
                        " characters"
                  );
               }
               if (
                  f.constraints.maxLength &&
                  value.length > f.constraints.maxLength
               ) {
                  return error(
                     e,
                     "Maximum length of " +
                        f.label +
                        " is " +
                        f.constraints.maxLength +
                        " characters"
                  );
               }
               if (
                  f.constraints.expression &&
                  !new RegExp(f.constraints.expression).test(value)
               ) {
                  return error(
                     e,
                     "Value of " + f.label + " did not match the pattern"
                  );
               }
            }
            // Handling number type
            else if (typeof value === "number") {
               if (
                  f.constraints.minValue !== undefined &&
                  value < f.constraints.minValue
               ) {
                  return error(
                     e,
                     "Minimum value of " +
                        f.label +
                        " is " +
                        f.constraints.minValue
                  );
               }
               if (
                  f.constraints.maxValue !== undefined &&
                  value > f.constraints.maxValue
               ) {
                  return error(
                     e,
                     "Maximum value of " +
                        f.label +
                        " is " +
                        f.constraints.maxValue
                  );
               }
            }
            //| NOTE: The last potential type for 'value' is `string[]`.
            //| This happens only when jQuery val() retrieves values from a multi-select element.
            //| As of 8 SEP 2023, our METADATA forms don't use multi-selects, so no need to handle this yet.
         }
         properties[f.name] = value;
      }
      return properties;
   }

   saveProperties(button: MatButton) {
      const properties = this.getProperties(this.metadataService.properties);
      if (!properties) {
         return;
      }
      button.disabled = true;
      this.translate.get("saving").subscribe((s) => {
         this.saveText = s;
      });
      this.metadataService.saveProperties(properties).subscribe(
         (isSuccess) => {
            this.translate.get("saved").subscribe((s) => {
               this.saveText = s;
            });
         },
         (error) => {},
         () => {
            setTimeout(() => {
               button.disabled = false;
               this.translate.get("save").subscribe((s) => {
                  this.saveText = s;
               });
            }, 5000);
         }
      );
   }

   loadForm1(properties: zDoxItem["properties"]) {
      this.componentRef1 = DocTypeComponent.create(
         this.resolver,
         this.componentRef1,
         this.form1,
         properties
      );
   }

   loadForm2(name: string) {
      this.form = undefined;
      this.service.getType(name).subscribe((data) => {
         this.form = data;
         this.componentRef2 = DocTypeComponent.create(
            this.resolver,
            this.componentRef2,
            this.form2,
            data
         );
         this.updateContainerHeight();
      });
   }
   saveType(button: MatButton, type: string) {
      const formType = {
         name: type,
         title: (<MatOption>this.selectType.selected).viewValue,
      };
      const properties = this.getProperties(this.form);
      if (!properties) {
         return;
      }
      button.disabled = true;
      this.translate.get("saving").subscribe((s) => {
         this.saveText = s;
      });

      this.metadataService
         .saveType(this.metadataService.doc.id, formType, properties)
         .subscribe(
            (isSuccess) => {
               if (isSuccess) {
                  this.translate.get("saved").subscribe((s) => {
                     this.saveText = s;
                  });
                  this.metadataService.properties = properties;
               }
            },
            (error) => {},
            () => {
               setTimeout(() => {
                  button.disabled = false;
                  this.translate.get("save").subscribe((s) => {
                     this.saveText = s;
                  });
               }, 5000);
            }
         );
   }
   private updateContainerHeight() {
      setTimeout(() => {
         const height =
            $(".info-body:visible").outerHeight(true) +
            $(".info-title").outerHeight(true);
         $(".list-container").css("min-height", height + "px");
         this.adjustInfoPosition();
      }, 100);
   }

   private adjustInfoPosition() {
      const SPACER = 58; // docList padding 20px + .content-container padding-bottom 38px
      const info = $(".info-body:visible");
      if (info.length === 0) {
         return;
      }

      const title = $(".info-title");
      const infoTop = title.position().top + title.outerHeight(true);
      const top = infoTop + "px";
      if (window.scrollY > 0) {
         // TODO: detect scroll direction and use to calc position instead of window.scrollY
         const height = info.outerHeight(true);
         if (window.innerHeight - infoTop - height < 0) {
            const x = window.innerHeight - SPACER;
            let y = infoTop - window.scrollY;
            if (y + height < x) {
               y = x - height;
            }
            info.css({ top: y + "px" });
         } else {
            info.css({ top: top });
         }
      } else {
         info.css({ top: top });
      }
   }
}
